
import { Box } from "@mui/material"
import { useMediaQuery } from "react-responsive"
import SignupStepperForm from "../forms/signup_stepper"
import background from "../assets/Background.webp"

const Signup=()=>{
    const isMobile = useMediaQuery({ maxWidth: 600 });

    return( <Box sx={{width:"100%",bgcolor:"black",display: "flex", alignItems: 'center', justifyContent: "center", flexDirection: 'column'}}>
    {!isMobile&& <Box sx={{height:"100vh",width:"100%"}} component='img' src={background} />}
     <SignupStepperForm />
     </Box>
     )
}

export default Signup
